import { render } from "./Our_Approach.vue?vue&type=template&id=f751b01e&scoped=true"
import script from "./Our_Approach.vue?vue&type=script&lang=js"
export * from "./Our_Approach.vue?vue&type=script&lang=js"

import "./Our_Approach.vue?vue&type=style&index=0&id=f751b01e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f751b01e"]])

export default __exports__